<script lang="ts">
  import { onMount } from "svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    counter?: number
  }

  let { counter = 0 }: Props = $props()

  let slide_type = $state(0)
  let value_slide = $state(0)

  onMount(() => {
    // This is kind of a hack to make sure we show all the different types of slides.
    // The Random Number generator approach was causing too many duplicates.
    //
    if (counter === 0) {
      slide_type = 0
    } else if (counter === 1) {
      slide_type = 2
      value_slide = 0
    } else if (counter === 2) {
      slide_type = 1
    } else if (counter === 3) {
      slide_type = 2
      if (appStore.plan_review.values.length >= 1) {
        value_slide = 1
      } else {
        value_slide = 0
      }
    } else if (counter === 4) {
      slide_type = 2
      if (appStore.plan_review.values.length >= 2) {
        value_slide = 2
      } else {
        slide_type = 0
      }
    } else if (counter === 5) {
      slide_type = 1
    } else if (counter === 6) {
      slide_type = 2
      if (appStore.plan_review.values.length >= 3) {
        value_slide = 3
      } else {
        slide_type = 0
      }
    } else if (counter === 7) {
      slide_type = 2
      if (appStore.plan_review.values.length >= 4) {
        value_slide = 4
      } else {
        slide_type = 0
      }
    } else {
      slide_type = getRandomInt(3)
      if (slide_type === 2) {
        value_slide = getRandomInt(appStore.plan_review.values.length)
      }
    }
  })

  function getRandomInt(max) {
    return Math.floor(Math.random() * max)
  }
</script>

<li class="splide__slide">
  <div class="bg-white rounded-lg shadow-lg">
    {#if slide_type === 0}
      <div class="w-full grid grid-cols-3 h-156">
        <div class="flex justify-center items-center py-6 px-6">
          <div class="py-4">
            <div class="text-base italic text-center">Highlighting Your</div>
            <div class="text-lg font-bold text-center mt-2">Brand Purpose</div>
            <img
              src={appStore.plan_review.brand_purpose.symbol_url}
              class="w-40 h-40 rounded-full mx-auto mt-8"
              alt={appStore.plan_review.brand_purpose.name}
            />
            <div class="text-2xl text-center mt-4">
              {appStore.plan_review.brand_purpose.name}
            </div>
          </div>
        </div>

        <div
          class="col-span-2 py-8 px-12 xl:px-16 2xl:px-20 border-l border-gray-200 flex flex-col justify-center items-center"
        >
          <div class="text-4xl font-bold text-center mt-2 mb-6">
            {appStore.plan_review.brand_purpose.name}
          </div>
          {#if appStore.plan_review.brand_purpose.description.length > 0}
            <div
              class="text-xl lg:text-2xl 2xl:text-3xl text-center py-4 xl:py-8 px-8 xl:px-12 2xl:px-16 bg-gray-50 text-gray-800 rounded-lg"
            >
              {@html appStore.plan_review.brand_purpose.description}
            </div>
          {:else}
            <div
              class="text-xl text-center py-4 px-8 bg-gray-50 text-gray-800 italic rounded-lg"
            >
              Please enter a description for your Brand Purpose.
            </div>
          {/if}
        </div>
      </div>
    {:else if slide_type === 1}
      <div class="w-full grid grid-cols-3 h-156">
        <div class="flex justify-center items-center py-6 px-6">
          <div class="py-4">
            <div class="text-base italic text-center">Highlighting Your</div>
            <div class="text-lg font-bold text-center mt-2">
              Blue Sky Vision
            </div>
            <img
              src={appStore.plan_review.blue_sky.symbol_url}
              class="w-40 h-40 rounded-full mx-auto mt-8"
              alt={appStore.plan_review.blue_sky.name}
            />
            <div class="text-xl text-center mt-4">
              {appStore.plan_review.blue_sky.name}
            </div>
          </div>
        </div>
        <div
          class="col-span-2 py-8 px-12 xl:px-16 2xl:px-20 border-l border-gray-200 flex flex-col justify-center items-center"
        >
          <div class="text-4xl font-bold text-center mt-2 mb-6">
            {appStore.plan_review.blue_sky.name}
          </div>
          {#if appStore.plan_review.blue_sky.description.length > 0}
            <div
              class="text-xl lg:text-2xl 2xl:text-3xl text-center py-4 xl:py-8 px-8 xl:px-12 2xl:px-16 bg-gray-50 text-gray-800 rounded-lg"
            >
              {@html appStore.plan_review.blue_sky.description}
            </div>
          {:else}
            <div
              class="text-xl text-center py-4 px-8 bg-gray-50 text-gray-800 italic rounded-lg"
            >
              Please enter a description for your Blue Sky Vision.
            </div>
          {/if}
        </div>
      </div>
    {:else if slide_type === 2}
      <div class="w-full grid grid-cols-3 h-156">
        <div class="flex justify-center items-center py-6 px-6">
          <div class="py-4">
            <div class="text-base italic text-center">Highlighting Your</div>
            <div class="text-lg font-bold text-center mt-2">Core Values</div>
            <img
              src={appStore.plan_review.values[value_slide].symbol_url}
              class="w-40 h-40 rounded-full mx-auto mt-8"
              alt={appStore.plan_review.values[value_slide].name}
            />
            <div class="text-xl text-center mt-4">
              {appStore.plan_review.values[value_slide].name}
            </div>
          </div>
        </div>
        <div
          class="col-span-2 py-8 px-12 xl:px-16 2xl:px-20 border-l border-gray-200 flex flex-col justify-center items-center"
        >
          <div class="text-4xl font-bold text-center mt-2 mb-6">
            {appStore.plan_review.values[value_slide].name}
          </div>
          {#if appStore.plan_review.values[value_slide].description.length > 0}
            <div
              class="text-xl lg:text-2xl 2xl:text-3xl text-center py-4 xl:py-8 px-8 xl:px-12 bg-gray-50 text-gray-800 rounded-lg"
            >
              {@html appStore.plan_review.values[value_slide].description}
            </div>
          {:else}
            <div
              class="text-xl text-center py-4 px-8 bg-gray-50 text-gray-800 italic rounded-lg"
            >
              Please enter a description for your {appStore.plan_review.values[
                value_slide
              ].name} Value.
            </div>
          {/if}
        </div>
      </div>
    {/if}
  </div>
</li>
